<template>
  <div class="main-wrapper" v-if="hosts">
    <template v-if="hosts.length > 0">
      <el-table :data="hosts" style="width: 100%">
        <el-table-column label="实例ID/名称">
          <template #default="scope">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
              target="_blank"
            >
              {{ getHostName(scope.row) }}
            </el-link>
            <br v-if="scope.row.nickName" />
            <el-link :underline="false" @click.prevent="btnNameClick(scope.row)">
              {{ scope.row.nickName }}
              <i class="el-icon-edit el-icon--right"></i>
            </el-link>
            <el-alert
              v-if="scope.row.isWarning"
              :title="scope.row.warningMessage"
              type="warning"
              :closable="false"
              show-icon
            ></el-alert>
          </template>
        </el-table-column>
        <el-table-column label="网站云版本" width="140">
          <template #default="scope">
            {{ getHostType(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="到期时间" width="140" align="center">
          <template #default="scope">
            <el-link :type="isExpiration(scope.row) ? 'danger' : 'success'" :underline="false" @click.prevent>
              {{ scope.row.expirationDate }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="140" align="center">
          <template #default="scope">
            <el-dropdown @command="btnMoreClick" :disabled="isExpiration(scope.row)">
              <el-link
                :type="scope.row.isRunning ? 'success' : 'danger'"
                :underline="false"
                href="javascript:;"
                class="el-dropdown-link"
              >
                {{ scope.row.isRunning ? '运行中' : '已停止' }}
                <i class="el-icon-arrow-down"></i>
              </el-link>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :disabled="scope.row.isRunning" :command="{ name: 'Start', host: scope.row }">
                    启动
                  </el-dropdown-item>
                  <el-dropdown-item :disabled="!scope.row.isRunning" :command="{ name: 'Stop', host: scope.row }">
                    停止
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ name: 'Reload', host: scope.row }">重启</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template #default="scope">
            <el-link
              v-if="!scope.row.isInstalled"
              type="primary"
              :disabled="!scope.row.isRunning || !scope.row.isPingPong"
              :underline="false"
              @click.prevent="btnInstallClick(scope.row, false)"
              style="margin-right: 10px"
            >
              初始化安装
            </el-link>
            <el-link
              v-if="scope.row.isInstalled"
              type="primary"
              :disabled="isExpiration(scope.row) || !scope.row.isRunning || !scope.row.isPingPong"
              :underline="false"
              :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong) + '/ss-admin/'"
              target="_blank"
              style="margin-right: 10px"
            >
              管理
            </el-link>
            <el-link
              v-if="scope.row.isInstalled"
              type="primary"
              :underline="false"
              @click.prevent="btnRenewalClick(scope.row)"
              style="margin-right: 10px"
            >
              续费
            </el-link>
            <el-link
              v-if="scope.row.isInstalled"
              type="primary"
              :disabled="isExpiration(scope.row)"
              :underline="false"
              @click.prevent="btnConnectionClick(scope.row)"
              style="margin-right: 10px"
            >
              连接信息
            </el-link>
            <el-dropdown v-if="scope.row.isInstalled" @command="btnMoreClick">
              <el-link type="primary" :underline="false" href="javascript:;" class="el-dropdown-link">
                更多
                <i class="el-icon-arrow-down"></i>
              </el-link>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    :disabled="isExpiration(scope.row) || !scope.row.isRunning || !scope.row.isPingPong"
                    :command="{ name: 'Domains', host: scope.row }"
                  >
                    域名绑定
                  </el-dropdown-item>
                  <el-dropdown-item
                    :disabled="isExpiration(scope.row) || !scope.row.isRunning || !scope.row.isPingPong"
                    :command="{ name: 'ResetPassword', host: scope.row }"
                  >
                    重置密码
                  </el-dropdown-item>
                  <el-dropdown-item
                    :disabled="isExpiration(scope.row) || !scope.row.isRunning || !scope.row.isPingPong"
                    :command="{ name: 'Backups', host: scope.row }"
                  >
                    系统备份
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.hostType !== 'Professional'"
                    :disabled="isExpiration(scope.row)"
                    :command="{ name: 'Upgrade', host: scope.row }">
                    升级配置
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-divider></el-divider>

      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" @click.prevent="btnAddClick">新建网站云</el-button>
        </el-form-item>
      </el-form>

      <el-drawer title="续费" direction="rtl" size="60%" v-if="isRenewal" v-model="isRenewal">
        <el-row :gutter="20">
          <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
            续费实例ID/名称：
            <el-link
              type="primary"
              :underline="false"
              :href="getUrl(host.hostName, host.nodeName, host.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(host) }}
              <span v-if="host.nickName">（{{ host.nickName }}）</span>
            </el-link>
          </el-col>
        </el-row>
        <el-form style="margin: 0 30px" ref="renewalForm" :model="renewalForm" label-position="top">
          <el-form-item label="到期时间">
            {{ host.expirationDate }}
          </el-form-item>
          <el-form-item label="续费时长" prop="year" :rules="{ required: true, message: '请输入服务器名称' }">
            <el-radio-group v-model="renewalForm.year">
              <el-radio-button :label="1">1年</el-radio-button>
              <el-radio-button :label="2">2年（8.5折）</el-radio-button>
              <el-radio-button :label="3">3年（8折）</el-radio-button>
              <el-radio-button :label="4">4年（7.5折）</el-radio-button>
              <el-radio-button :label="5">5年（7折）</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务协议" prop="agreement">
            <el-checkbox v-model="renewalForm.agreement">同意</el-checkbox>
            <el-link href="/home/cloud-agreement.html" target="_blank" style="margin-top: -3px">网站云服务协议</el-link>
          </el-form-item>
          <el-form-item label="费用合计">
            <span style="font-size: 18px; color: #fa5300">￥{{ getPayAmount().toFixed(2) }}</span>
          </el-form-item>
          <el-divider></el-divider>

          <div class="el-dialog__footer">
            <el-button type="primary" :disabled="!renewalForm.agreement" @click="btnRenewalSubmitClick">确 定</el-button>
            <el-button @click="isRenewal = false">取 消</el-button>
          </div>
        </el-form>
      </el-drawer>

      <el-drawer title="升级配置" direction="rtl" size="60%" v-if="isUpgrade" v-model="isUpgrade">
        <el-row :gutter="20">
          <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
            升级配置实例ID/名称：
            <el-link
              type="primary"
              :underline="false"
              :href="getUrl(host.hostName, host.nodeName, host.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(host) }}
              <span v-if="host.nickName">（{{ host.nickName }}）</span>
            </el-link>
          </el-col>
        </el-row>
        <el-form style="margin: 10px 30px" ref="upgradeForm" :model="upgradeForm" label-position="top">
          <el-form-item label="当前实例版本">
            {{ getHostType(host) }}
          </el-form-item>
          <el-form-item label="到期时间">
            {{ host.expirationDate }}
          </el-form-item>
          <el-form-item label="升级网站云版本" prop="hostType" :rules="{ required: true, message: '请选择升降网站云版本' }">
            <el-radio-group v-model="upgradeForm.hostType" @change="btnUpgradeHostTypeChanged">
              <el-radio-button :disabled="true" label="Starter">入门版（¥{{ priceStarter }}/年）</el-radio-button>
              <el-radio-button :disabled="host.hostType === 'Standard' || host.hostType === 'Professional'" label="Standard">
                标准版（¥{{ priceStandard }}/年）
              </el-radio-button>
              <el-radio-button :disabled="host.hostType === 'Professional'" label="Professional">
                专业版（¥{{ priceProfessional }}/年）
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="upgradeForm.amount" label="升级费用合计">
            <span style="font-size: 18px; color: #fa5300">￥{{ upgradeForm.amount.toFixed(2) }}</span>
          </el-form-item>
          <el-divider></el-divider>

          <div class="el-dialog__footer">
            <el-button type="primary" :disabled="host.hostType === upgradeForm.hostType" @click="btnUpgradeSubmitClick">
              确 定
            </el-button>
            <el-button @click="isUpgrade = false">取 消</el-button>
          </div>
        </el-form>
      </el-drawer>

      <el-dialog title="在线付款" v-if="isPay" v-model="isPay">
        <template v-if="payForm.isPurchased">
          <div style="text-align: center">
            <h2 v-html="payForm.message" style="text-align: center; color: #67c23a"></h2>
            <el-button type="primary" v-on:click="btnPayCloseClick">关 闭</el-button>
          </div>
        </template>
        <template v-else-if="payForm.isQrCode">
          <div style="text-align: center">
            <h2>打开手机{{ getChannel() }}，扫一扫下面的二维码，即可完成支付</h2>
            <div style="margin: 10px auto">
              <img v-if="payForm.channel == 'AliPay'" src="/home/img/channel_alipay.gif" />
              <img v-else src="/home/img/channel_weixin.gif" />
            </div>
            <canvas id="qrcode" style="margin: 0px auto; width: 260px; height: 260px"></canvas>
          </div>
        </template>
        <template v-else>
          <div style="margin-bottom: 10px; border: 1px solid #ebebeb; border-radius: 3px">
            <div style="padding: 24px">
              <h3 style="text-align: center; margin-bottom: 40px" v-html="getPayDescription()"></h3>

              <el-divider></el-divider>

              <div>
                <div style="text-align: center">
                  <div
                    style="
                      width: 49%;
                      text-align: center;
                      border-right: 1px solid #eff2f6;
                      display: inline-block;
                      width: 49%;
                      box-sizing: border-box;
                      vertical-align: top;
                    "
                  >
                    <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                      <img src="/home/img/channel_alipay.gif" />
                    </span>
                    <div class="el-image">
                      <el-button type="primary" v-on:click="btnPayChannelClick('AliPay')">使用支付宝支付</el-button>
                    </div>
                  </div>
                  <div
                    style="
                      width: 49%;
                      text-align: center;
                      display: inline-block;
                      width: 49%;
                      box-sizing: border-box;
                      vertical-align: top;
                    "
                  >
                    <span style="display: block; color: #8492a6; font-size: 14px; margin: 20px 0">
                      <img src="/home/img/channel_weixin.gif" />
                    </span>
                    <div class="el-image">
                      <el-button type="primary" v-on:click="btnPayChannelClick('WxPay')">使用微信支付</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <p style="height: 30px"></p>
      </el-dialog>

      <el-dialog title="编辑实例名称：" v-if="isNameForm" v-model="isNameForm" width="40%">
        <el-form style="margin: 0 10px" ref="form" :model="nameForm" label-position="left" label-width="120px">
          <el-form-item label="实例名称" prop="nickName" :rules="{ required: true, message: '请输入实例名称' }">
            <el-input v-model="nameForm.nickName" placeholder="请输入实例名称"></el-input>
          </el-form-item>
          <el-divider></el-divider>

          <div class="el-dialog__footer">
            <el-button type="primary" @click="btnNameSubmitClick">确 定</el-button>
            <el-button @click="isNameForm = false">取 消</el-button>
          </div>
        </el-form>
      </el-dialog>

      <el-drawer title="连接信息" direction="rtl" size="60%" v-if="isConnections" v-model="isConnections">
        <el-table :data="connections" :show-header="false" style="width: 100%; margin: 0 10px" stripe size="large">
          <el-table-column prop="name" label="" width="180">
            <template #default="scope">
              <strong>{{ scope.row.name }}</strong>
            </template>
          </el-table-column>
          <el-table-column label="">
            <template #default="scope">
              <div v-html="scope.row.description"></div>
              <el-link v-if="scope.row.docUrl" type="primary" :underline="false" :href="scope.row.docUrl" target="_blank">
                使用帮助
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>

      <el-drawer title="系统备份" direction="rtl" size="40%" v-if="isBackups" v-model="isBackups">
        <backups :hostId="host.id" />
      </el-drawer>

      <el-drawer title="域名绑定" direction="rtl" size="60%" v-if="isDomains" v-model="isDomains">
        <domains :hostId="host.id" />
      </el-drawer>

      <el-drawer
        :title="isInstall ? '初始化安装' : '重置密码'"
        direction="rtl"
        size="60%"
        v-if="isInstallOrResetPassword"
        v-model="isInstallOrResetPassword"
      >
        <el-row :gutter="20">
          <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
            实例ID/名称：
            <el-link
              type="primary"
              :underline="false"
              :href="getUrl(host.hostName, host.nodeName, host.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(host) }}
              <span v-if="host.nickName">（{{ host.nickName }}）</span>
            </el-link>
          </el-col>
        </el-row>
        <el-alert
          v-if="isResetPassword"
          :closable="false"
          title="如果超级管理员账号已存在，系统将重置密码，否则系统将新建超级管理员账号密码"
          type="error"
        ></el-alert>
        <el-form style="margin: 15px 30px 0" ref="installForm" :model="installForm" label-position="top">
          <el-form-item label="超级管理员账号" prop="userName" :rules="[{ required: true, message: '请输入超级管理员账号' }]">
            <el-input autocomplete="off" v-model="installForm.userName" placeholder="请输入超级管理员账号"></el-input>
            <div class="tips">设置 SSCMS 后台的超级管理员账号</div>
          </el-form-item>
          <el-form-item label="超级管理员密码" prop="password" :rules="[{ required: true, message: '请输入超级管理员密码' }]">
            <el-input type="password" autocomplete="off" v-model="installForm.password" placeholder="请输入自定义域名"></el-input>
            <div class="tips">设置 SSCMS 后台的超级管理员密码</div>
          </el-form-item>
          <el-form-item
            label="超级管理员确认密码"
            prop="confirmPassword"
            :rules="[{ required: true, message: '请输入确认密码' }, { validator: validatePass }]"
          >
            <el-input
              type="password"
              autocomplete="off"
              v-model="installForm.confirmPassword"
              placeholder="请输入超级管理员确认密码"
            ></el-input>
            <div class="tips">请再次确认密码</div>
          </el-form-item>
          <el-divider></el-divider>

          <div class="el-dialog__footer">
            <el-button type="primary" @click="btnInstallSubmitClick">确 定</el-button>
            <el-button @click="isInstallOrResetPassword = false">取 消</el-button>
          </div>
        </el-form>
      </el-drawer>
    </template>
    <template v-else>
      <empty></empty>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IHost } from '@/types/models';
import { HostType, ResourceType } from '@/types/enums';
import api from '@/api/my/hosts';
import agentPing from '@/api/agent/ping';
import agentInstall from '@/api/agent/install';
import agentAddSite from '@/api/agent/addSite';
import QRCode from 'qrcode';
import utils from '@/utils';
import Backups from './components/hosts/Backups.vue';
import Domains from './components/hosts/Domains.vue';
import Empty from './components/hosts/Empty.vue';

interface IRenewalForm {
  year: number;
  agreement: boolean;
}

interface IUpgradeForm {
  hostType: string;
  amount: number;
}

interface IPayForm {
  resourceType: string;
  hostId: number;
  hostType: string;
  year: number;
  amount: number;
  message: string;
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface INameForm {
  id: number;
  nickName: string;
}

interface IConnection {
  name: string;
  description: string;
  docUrl: string;
}

interface IInstallForm {
  securityKey: string;
  themeName: string;
  themeDownloadUrl: string;
  guid: string;
  userName: string;
  password: string;
  confirmPassword: string;
}

interface IState {
  hosts: IHost[] | null;
  host: IHost;
  priceStarter: number;
  priceStandard: number;
  priceProfessional: number;
  discount1Year: number;
  discount2Year: number;
  discount3Year: number;
  discount4Year: number;
  discount5Year: number;
  isRenewal: boolean;
  renewalForm: IRenewalForm;
  isPay: boolean;
  payForm: IPayForm;
  isNameForm: boolean;
  nameForm: INameForm;
  isConnections: boolean;
  connections: IConnection[];
  isBackups: boolean;
  isUpgrade: boolean;
  upgradeForm: IUpgradeForm;
  isDomains: boolean;
  isInstallOrResetPassword: boolean;
  isInstall: boolean;
  isResetPassword: boolean;
  installForm: IInstallForm;
}

export default defineComponent({
  components: {
    Backups,
    Domains,
    Empty,
  },
  data() {
    return {
      hosts: null,
      host: {} as IHost,
      priceStarter: 0,
      priceStandard: 0,
      priceProfessional: 0,
      discount1Year: 0,
      discount2Year: 0,
      discount3Year: 0,
      discount4Year: 0,
      discount5Year: 0,
      isRenewal: false,
      renewalForm: {} as IRenewalForm,
      isPay: false,
      payForm: {} as IPayForm,
      isNameForm: false,
      nameForm: {} as INameForm,
      isConnections: false,
      connections: [],
      isBackups: false,
      isUpgrade: false,
      upgradeForm: {} as IUpgradeForm,
      isDomains: false,
      isInstallOrResetPassword: false,
      isInstall: false,
      isResetPassword: false,
      installForm: {} as IInstallForm,
    } as IState;
  },
  methods: {
    apiGet(pingHostId?: number) {
      api.get((res) => {
        this.hosts = res.hosts;
        this.priceStarter = res.priceStarter;
        this.priceStandard = res.priceStandard;
        this.priceProfessional = res.priceProfessional;
        this.discount1Year = res.discount1Year;
        this.discount2Year = res.discount2Year;
        this.discount3Year = res.discount3Year;
        this.discount4Year = res.discount4Year;
        this.discount5Year = res.discount5Year;

        for (const host of this.hosts) {
          host.pingPongCount = 0;
          host.isPingPong = true;
          if (!host.isInstalled || host.id === pingHostId) {
            host.isPingPong = false;
            this.apiPing(host);
          }
        }
      });
    },

    apiPing(host: IHost) {
      agentPing.ping(host.hostName, host.nodeName, host.isHongKong, (pong: string) => {
        if (pong === 'pong') {
          host.isPingPong = true;
          host.pingPongCount = 0;
        } else {
          host.isPingPong = false;
          host.pingPongCount += 1;
          if (host.pingPongCount < 20) {
            setTimeout(() => {
              this.apiPing(host);
            }, 3000);
          }
        }
      });
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getHostName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getUniqueName(host: IHost): string {
      return utils.getHostUniqueName(host);
    },

    isExpiration(host: IHost): boolean {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      const expirationDate = new Date(host.expirationDate);
      return expirationDate.getTime() <= date.getTime();
    },

    btnNameClick(host: IHost) {
      this.nameForm.id = host.id;
      this.nameForm.nickName = host.nickName;
      this.isNameForm = true;
    },

    btnAddClick() {
      utils.pageOpen('/my/create/empty');
    },

    btnRenewalClick(host: IHost) {
      this.host = { ...host };
      this.renewalForm.year = 1;
      this.renewalForm.agreement = false;
      this.isRenewal = true;
    },

    btnPayCloseClick() {
      this.isPay = false;
      this.isRenewal = false;
      this.isUpgrade = false;
      this.payForm.isPurchased = false;
      this.payForm.isQrCode = false;
      this.apiGet();
    },

    btnRenewalSubmitClick() {
      this.payForm.resourceType = ResourceType.HostRenewal;
      this.payForm.hostId = this.host.id;
      this.payForm.hostType = this.host.hostType;
      this.payForm.year = this.renewalForm.year;
      this.payForm.amount = this.getPayAmount();
      this.payForm.failureCount = 0;
      this.isPay = true;
    },

    btnUpgradeSubmitClick() {
      this.payForm.resourceType = ResourceType.HostUpgrade;
      this.payForm.hostId = this.host.id;
      this.payForm.hostType = this.upgradeForm.hostType;
      this.payForm.year = 0;
      this.payForm.amount = this.upgradeForm.amount;
      this.payForm.failureCount = 0;
      this.isPay = true;
    },

    getPayDescription() {
      if (this.isRenewal) {
        const hostType = utils.getHostType(this.host.hostType);
        const op = '续费时长';
        const amount = this.getPayAmount().toFixed(2);
        return `
          网站云版本:
          <span style="color: #fa5300; margin-right: 15px">${hostType}</span>
          ${op}:
          <span style="color: #fa5300; margin-right: 15px">${this.payForm.year}年</span>
          费用合计:
          <span style="color: #fa5300">￥${amount}</span>`;
      }
      if (this.isUpgrade) {
        const hostType = utils.getHostType(this.upgradeForm.hostType);
        const amount = this.upgradeForm.amount.toFixed(2);
        return `
          升级版本:
          <span style="color: #fa5300; margin-right: 15px">${hostType}</span>
          费用合计:
          <span style="color: #fa5300">￥${amount}</span>`;
      }
      return '';
    },

    getPayAmount(): number {
      const { hostType } = this.host;
      const { year } = this.renewalForm;

      let price = 0;
      if (hostType === HostType.Starter) {
        price = this.priceStarter;
      } else if (hostType === HostType.Standard) {
        price = this.priceStandard;
      } else if (hostType === HostType.Professional) {
        price = this.priceProfessional;
      }
      let discount = 1;
      if (year === 1) {
        discount = this.discount1Year;
      } else if (year === 2) {
        discount = this.discount2Year;
      } else if (year === 3) {
        discount = this.discount3Year;
      } else if (year === 4) {
        discount = this.discount4Year;
      } else if (year === 5) {
        discount = this.discount5Year;
      }
      return price * year * discount;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;
            this.payForm.message = res.message;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
              setTimeout(() => {
                this.btnPayCloseClick();
              }, 3000);
            }
          },
        );
      }, 3000);
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          resourceType: this.payForm.resourceType,
          hostId: this.payForm.hostId,
          hostType: this.payForm.hostType,
          year: this.payForm.year,
          channel: this.payForm.channel,
          amount: this.payForm.amount,
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    btnNameSubmitClick() {
      api.name(
        {
          id: this.nameForm.id,
          nickName: this.nameForm.nickName,
        },
        (res) => {
          if (!res) return;
          this.isNameForm = false;
          this.apiGet();
        },
      );
    },

    btnConnectionClick(host: IHost) {
      api.credentialsGet(host.id, (res) => {
        this.connections = utils.getHostConnections(
          host,
          res.isHongKong,
          res.securityKey,
          res.ftpPassword,
          res.databaseHost,
          res.databaseUser,
          res.databasePassword,
          res.databaseName,
        );
        this.isConnections = true;
      });
    },

    btnMoreClick(args: { name: string; host: IHost }) {
      this.host = { ...args.host };
      if (args.name === 'Domains') {
        this.isDomains = true;
      } else if (args.name === 'ResetPassword') {
        this.btnInstallClick(args.host, true);
      } else if (args.name === 'Backups') {
        this.isBackups = true;
      } else if (args.name === 'Upgrade') {
        this.isUpgrade = true;
        this.upgradeForm.hostType = this.host.hostType;
        this.upgradeForm.amount = 0;
      } else if (args.name === 'Start') {
        utils.alertDelete(
          {
            title: '启动实例',
            text: `此操作将启动实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认启动',
          },
          () => {
            api.start({ hostId: args.host.id }, () => {
              utils.success('实例启动成功！');
              this.apiGet(args.host.id);
            });
          },
        );
      } else if (args.name === 'Stop') {
        utils.alertDelete(
          {
            title: '停止实例',
            text: `此操作将停止实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认停止',
          },
          () => {
            api.stop({ hostId: args.host.id }, () => {
              utils.success('实例停止成功！');
              this.apiGet();
            });
          },
        );
      } else if (args.name === 'Reload') {
        utils.alertDelete(
          {
            title: '重启实例',
            text: `此操作将重启实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认重启',
          },
          () => {
            api.reload({ hostId: args.host.id }, () => {
              utils.success('实例重启成功！');
              this.apiGet(args.host.id);
            });
          },
        );
      }
    },

    btnUpgradeHostTypeChanged(hostType: string) {
      if (hostType === this.host.hostType) {
        this.upgradeForm.amount = 0;
      } else {
        api.upgrade(
          {
            hostId: this.host.id,
            hostType: this.upgradeForm.hostType,
          },
          (res) => {
            if (!res) return;
            this.upgradeForm.amount = res.amount;
          },
        );
      }
    },

    btnInstallClick(host: IHost, isResetPassword: boolean) {
      this.host = { ...host };
      api.installGet(host.id, (res) => {
        this.installForm.securityKey = res.securityKey;
        this.installForm.themeName = res.themeName;
        this.installForm.themeDownloadUrl = res.themeDownloadUrl;
        this.installForm.guid = res.guid;
        this.installForm.userName = '';
        this.installForm.password = '';
        this.installForm.confirmPassword = '';
        this.isInstallOrResetPassword = true;
        if (isResetPassword) {
          this.isInstall = false;
          this.isResetPassword = true;
        } else {
          this.isInstall = true;
          this.isResetPassword = false;
        }
      });
    },

    apiInstallSubmit() {
      api.installSubmit(
        {
          hostId: this.host.id,
          userName: this.installForm.userName,
          password: this.installForm.password,
        },
        (res) => {
          if (res.value) {
            if (this.isInstall) {
              utils.success('恭喜，初始化安装成功');
              this.isInstall = false;
            } else if (this.isResetPassword) {
              utils.success('恭喜，重置密码成功');
              this.isResetPassword = false;
            }
            this.isInstallOrResetPassword = false;
            this.isInstall = false;
            this.isResetPassword = false;
            this.apiGet();
            utils.loading(false);
          }
        },
      );
    },

    apiAgentInstall(success: () => void) {
      agentInstall.install(
        this.host.hostName,
        this.host.nodeName,
        this.host.isHongKong,
        {
          securityKey: this.installForm.securityKey,
          userName: this.installForm.userName,
          password: this.installForm.password,
        },
        (res) => {
          if (res.value) {
            success();
          }
        },
      );
    },

    apiAgentAddSite(success: () => void) {
      agentAddSite.addSite(
        this.host.hostName,
        this.host.nodeName,
        this.host.isHongKong,
        {
          securityKey: this.installForm.securityKey,
          siteName: this.installForm.themeName,
          root: true,
          parentId: 0,
          siteDir: this.installForm.themeName,
          themeDownloadUrl: this.installForm.themeDownloadUrl,
          guid: this.installForm.guid,
        },
        (res) => {
          if (res.site) {
            success();
          }
        },
        (errorMessage) => {
          utils.loading(false);
          utils.error(errorMessage);
        },
      );
    },

    btnInstallSubmitClick() {
      utils.loading(true);
      this.apiAgentInstall(() => {
        if (this.installForm.themeDownloadUrl && this.installForm.guid) {
          this.apiAgentAddSite(() => {
            this.apiInstallSubmit();
          });
        } else {
          this.apiInstallSubmit();
        }
      });
    },

    validatePass(rule: string, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.installForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
  },
  // mounted() {
  //   this.apiGet();
  // },
  created() {
    this.$watch(
      () => this.$route.query,
      () => {
        this.apiGet();
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true },
    );
  },
});
</script>
